import { gql } from "generated-graphql";

/** Grid list fields. Comments + shared-count are drawer-only (see detail fragment). */
export const CREDENTIAL_IMPLEMENTATION_FOR_STAFF_LIST_FIELDS = gql(`
  fragment CredentialImplementationForStaffListFields on CredentialImplementationForStaff {
    id
    tenantId
    tenantName
    state
    portalJurisdiction
    portalName
    facilityId
    facilityName
    facilityAddress
    county
    credentialName
    credentialEmail
    credentialInEncamp
    implementationStatus
    credentialStatus
    lastVerifiedAt
    lockHolder
    lockExpiresAt
    seenInPortal
    stateId
    stateIdType
    csmName
    csmEmail
    assigneeId
    assigneeName
    assigneeEmail
    mostRecentComment
    mostRecentCommentAt
    notes
    blockedReason
  }
`);

/** Drawer fragment: list fields + full comment thread + shared-count chip. */
export const CREDENTIAL_IMPLEMENTATION_FOR_STAFF_DETAIL_FIELDS = gql(`
  fragment CredentialImplementationForStaffDetailFields on CredentialImplementationForStaff {
    ...CredentialImplementationForStaffListFields
    credentialId
    sharedCredentialImplementationCount
    comments {
      ...CommentThread
      credentialImplementationId
    }
  }
`);

export const CREDENTIAL_IMPLEMENTATIONS_FOR_STAFF_QUERY = gql(`
  query CredentialImplementationsForStaff(
    $search: String
    $page: Int
    $pageSize: Int
    $sort: [SortModel!]
  ) {
    credentialImplementationsForStaff(
      search: $search
      page: $page
      pageSize: $pageSize
      sort: $sort
    ) {
      items {
        ...CredentialImplementationForStaffListFields
      }
      count
    }
  }
`);

/** Login payload for the drawer's "Open with Encampy" launcher. Password is gated server-side by ViewCredentials. */
export const CREDENTIAL_FOR_PORTAL_LOGIN_QUERY = gql(`
  query CredentialForPortalLogin($id: ID!) {
    credential(id: $id) {
      id
      username
      password
      securityQuestions {
        question
        answer
      }
      portal {
        type
        url
        portalTech
      }
    }
  }
`);

export const CREDENTIAL_IMPLEMENTATION_FOR_STAFF_QUERY = gql(`
  query CredentialImplementationForStaff($id: ID!) {
    credentialImplementationForStaff(id: $id) {
      ...CredentialImplementationForStaffDetailFields
    }
  }
`);

export const UPDATE_CREDENTIAL_IMPLEMENTATION = gql(`
  mutation UpdateCredentialImplementation(
    $id: ID!
    $input: UpdateCredentialImplementationInput!
  ) {
    updateCredentialImplementation(id: $id, input: $input) {
      ...CredentialImplementationForStaffDetailFields
    }
  }
`);

export const ADD_CREDENTIAL_IMPLEMENTATION_COMMENT = gql(`
  mutation AddCredentialImplementationComment(
    $credentialImplementationId: ID!
    $comment: String!
  ) {
    addCredentialImplementationComment(
      credentialImplementationId: $credentialImplementationId
      comment: $comment
    ) {
      ...CommentThread
      credentialImplementationId
    }
  }
`);

export const BULK_SET_CI_ASSIGNEE = gql(`
  mutation BulkSetCredentialImplementationAssignee($ids: [ID!]!, $assigneeId: ID) {
    bulkSetCredentialImplementationAssignee(ids: $ids, assigneeId: $assigneeId) {
      updated
    }
  }
`);

export const BULK_SET_CI_STATUS = gql(`
  mutation BulkSetCredentialImplementationStatus(
    $ids: [ID!]!
    $implementationStatus: ImplementationStatus!
    $blockedReason: String
  ) {
    bulkSetCredentialImplementationStatus(
      ids: $ids
      implementationStatus: $implementationStatus
      blockedReason: $blockedReason
    ) {
      updated
    }
  }
`);

export const BULK_SET_CI_NOTES = gql(`
  mutation BulkSetCredentialImplementationNotes($ids: [ID!]!, $notes: String!) {
    bulkSetCredentialImplementationNotes(ids: $ids, notes: $notes) {
      updated
    }
  }
`);
